var EVENTS = {
  RESIZE: "resize",
  CHANGE: "change",
  OFF: "off",
  UPDATE: "update"
};
export { EVENTS };



//////////////////
// WEBPACK FOOTER
// ./node_modules/_xgplayer-subtitles@3.0.5@xgplayer-subtitles/es/constants.js
// module id = null
// module chunks = 